import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AthleteAuthContextProvider } from './athlete/login/AthleteAuthContext';
import { CoachAuthContextProvider } from './coach/login/CoachAuthContext';
import { StaffAuthContextProvider } from './administrator/staff/StaffAuthContext';
import Modal from "react-modal";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);


const root = ReactDOM.createRoot(document.getElementById('root'));
Modal.setAppElement("#root"); // Call this once in your main entry file (App.js or index.js)

root.render(
  <React.StrictMode>
    <StaffAuthContextProvider>
      <CoachAuthContextProvider>
          <AthleteAuthContextProvider>
            {/* ✅ Wrap App with Stripe Elements */}
            <Elements stripe={stripePromise}>
              <App />
            </Elements>
          </AthleteAuthContextProvider>
      </CoachAuthContextProvider>
    </StaffAuthContextProvider>
  </React.StrictMode>
);